import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import messageSlice from "./MessageSlice";
import BaseApi from "../Http/BaseApi";
import {
  clearAuthUserData,
  persistAuthUserData,
  stripStoredAuthToken,
} from "../Utils/authSession";

stripStoredAuthToken();
const user = JSON.parse(localStorage.getItem("userData"));

export const postLoginAsync = createAsyncThunk(
  "auth/postLoginAsync",
  async (data, thunkAPI) => {
    const { payload } = data;

    try {
      const response = await BaseApi(payload.panel).post("login", payload);

      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      thunkAPI.dispatch(messageSlice.actions.setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const postVerify2faAsync = createAsyncThunk(
  "auth/postVerify2faAsync",
  async (data, thunkAPI) => {
    const { payload } = data;

    try {
      const response = await BaseApi(payload.panel || "staff").post(
        "login/verify-2fa",
        payload
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      thunkAPI.dispatch(messageSlice.actions.setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const postResend2faAsync = createAsyncThunk(
  "auth/postResend2faAsync",
  async (data, thunkAPI) => {
    const { payload } = data;

    try {
      const response = await BaseApi(payload.panel || "staff").post(
        "login/resend-2fa",
        payload
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      thunkAPI.dispatch(messageSlice.actions.setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const postChangePasswordAsync = createAsyncThunk(
  "auth/postChangePasswordAsync",
  async (data, thunkAPI) => {
    const { payload } = data;

    try {
      const response = await BaseApi(payload.panel).post(
        "change-password",
        payload
      );

      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      thunkAPI.dispatch(messageSlice.actions.setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const logout = createAsyncThunk("auth/logout", async () => {
  await BaseApi()
    .post("logout")
    .then(() => {
      clearAuthUserData();
    })
    .catch(() => {
      clearAuthUserData();
    });
});

const initialState = user
  ? { isLoggedIn: true, user: user.user, panel: user.panel }
  : { isLoggedIn: false, user: null, panel: null };

const applyLoginSuccess = (state, action) => {
  if (action.payload?.requires_2fa) {
    return;
  }
  state.isLoggedIn = true;
  state.user = action.payload.user;
  state.panel = action.payload.panel;
  persistAuthUserData(action.payload);
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: {
    [postLoginAsync.fulfilled]: applyLoginSuccess,
    [postVerify2faAsync.fulfilled]: applyLoginSuccess,

    [postLoginAsync.rejected]: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.panel = null;
    },
    [postVerify2faAsync.rejected]: () => {},
    [logout.fulfilled]: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.panel = null;
    },
    [logout.rejected]: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.panel = null;
    },
    [postChangePasswordAsync.fulfilled]: () => {},
  },
});

export default authSlice;
